import React, { useState } from 'react';
import { get as _get } from 'lodash-es';
import PopupBundler from '../popups/PopupBundler';
import CompatioAnalytics from '../../api/CompatioAnalytics';

const ProductAddToCart = ({
  _singleProduct,
  _variantId,
  _baseItemId,
  _userId,
  _singleProductName,
  _singleProductImage,
  _singleProductPrice,
  isReel,
  _singleProductCat,
  rootProductData,
  _finalProductID,
  _parentProductID,
  _parentProductName,
  _source,
  _version,
}) => {
  const [ShowOptions, SetShowOptions] = useState(false);

  const handleAddClick = singleProduct => {
    // console.log(_singleProduct.merchantParentProductId,_singleProduct.merchantProductSku,'singleProduct')
    // CompatioAnalytics.track(CompatioAnalytics.events.xrsAddToCartClick, {
    //   variant_id: singleProduct.merchantProductSku,
    //   product_name: singleProduct.productName,
    //   click_action: CompatioAnalytics.clicks.xrsAddToCart,
    // });
  };

  //to be moved to HelperMethods.js
  const getDefaultBacking = () => {
    const backingdata = _get(
      window,
      'compatioConfig.compatibleProducts.backingData'
    );
    return backingdata[0] && backingdata[0].variantId;
  };
  const toggleBundler = () => {
    SetShowOptions(false);
  };
  return (
    <>
      <input
        type="button"
        value="Add to cart"
        id={`AddToCart-${_variantId}`}
        data-baseitemid={_baseItemId}
        data-baseparantitemid={_singleProduct.merchantParentProductId}
        data-userid={_userId}
        className="xrsbutton btn btn--full"
        data-section-id={_variantId}
        data-product-handle={_singleProduct.productHandle}
        data-product-url={_singleProduct.url_product}
        data-product-name={_singleProductName}
        data-product-img={_singleProductImage}
        data-product-price={_singleProductPrice}
        data-product-category={_singleProductCat}
        data-base-productid={_finalProductID}
        data-base-parant-productid={_parentProductID ? _parentProductID : 0}
        data-base-product-name={_parentProductName}
        data-source={_source}
        data-version={_version}
        onClick={() => {
          SetShowOptions(true);
          handleAddClick(_singleProduct);
        }}
      />
      {/* {_singleProduct.merchantParentProductId}
      <br></br>
      {_singleProduct.merchantProductSku}sdf */}
      {isReel && ShowOptions ? (
        <PopupBundler
          isOpen={ShowOptions}
          bundlerType="xrsoptions"
          toggleBundler={toggleBundler}
          parentProduct={_singleProduct}
          parentProductSku={_singleProduct.merchantProductSku}
          bundledProduct={_singleProduct.merchantProductSku}
          defaultBacking={getDefaultBacking()}
          rootProductData={rootProductData}
          dataBaseProductid={_finalProductID}
          dataBaseparantProductid={_parentProductID ? _parentProductID : 0}
          dataBaseproductName={_parentProductName}
          dataSource={_source}
          dataVersion={_version}
        />
      ) : null}
    </>
  );
};

export default ProductAddToCart;
